import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resets scroll position on navigation.
 *
 * A browser restores scroll on history navigation but a client-side route
 * change is not one, so without this a visitor lands mid-page. Renders
 * nothing; it exists purely for the effect.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
